import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';

export const TopHeaderWrapper = styled.div`
  ${flex({ alignItems: 'center' })};
  padding: 14px 36px;
  background-color: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.grey[200]};
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
  z-index: 1;

  ${media.tablet`
    padding: 16px 24px;
  `}

  ${media.mobile`
    padding: 16px;
  `}
`;
